export default __webpack_public_path__ + "static/media/review-placeholder.6e7b4ad4.png";